import React, { useEffect } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Row, Col, Button } from 'reactstrap';
import renderField from '../../../shared/components/custom/Field';
import t, { partial } from '../../../util/translation/translation';
import RenderSelectField from '../../../shared/components/form/Select';

const s = partial('shared');
const c = partial('CompanyForm');
const p = partial('auctionObjectsShared');

const AuctionDeliveryModal = ({ selectedBid, initialize, handleSubmit }) => {
  useEffect(() => {
    initialize({
      name: selectedBid?.deliveryDetails?.name,
      phone: selectedBid?.deliveryDetails?.phone,
      address: selectedBid?.deliveryDetails?.address,
      city: selectedBid?.deliveryDetails?.city,
      zip: selectedBid?.deliveryDetails?.zip,
      email: selectedBid?.deliveryDetails?.email,
      deliveryStatus: selectedBid?.deliveryDetails?.deliveryStatus,
    });
  }, [selectedBid]);
  const fields = [
    { name: 'name', label: s('name') },
    { name: 'phone', label: s('phonenumber') },
    { name: 'address', label: s('address') },
    { name: 'city', label: c('city') },
    { name: 'zip', label: c('zip') },
    { name: 'email', label: s('email') },
  ];
  const deliveryLabels = [
    {
      label: p('deliveryStatusSent'),
      value: 'SENT',
    },
    {
      label: p('deliveryStatusNotSent'),
      value: 'NOT_SENT',
    },
  ];

  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__form-group">
        {fields.map((field) => (
          <Row>
            <Col>
              <span className="form-header bold">{field.label}</span>
              <Field name={field.name} component={renderField} disabled />
            </Col>
          </Row>
        ))}
      </div>
      <Row>
        <Col>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {p('chooseDeliveryStatus')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="deliveryStatus"
                component={RenderSelectField}
                placeholder={p('chooseDeliveryStatus')}
                options={deliveryLabels}
              />
            </div>
            <Button color="primary">{s('save')}</Button>
          </div>
        </Col>
      </Row>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'AuctionDeliveryModal',
});
export default reduxF(AuctionDeliveryModal);
